var firstFocusElement, lastFocusElement;

// Trap focus when the mobile nav is open.
function onKeyDown(event) {
  if (event.isComposing) {
    return;
  }

  switch (event.key) {
    case 'Escape':
      toggleMenu(document.getElementById('menu-button'));
      firstFocusElement.focus();
      event.preventDefault();
    break;
    case 'Tab':
			console.log(event.target);
      if (event.shiftKey && event.target === firstFocusElement) {
        lastFocusElement.focus();
        event.preventDefault();
      }
      if (!event.shiftKey && event.target === lastFocusElement) {
        firstFocusElement.focus();
        event.preventDefault();
      }
    break;
    default:
      // do nothing
  }
  return;
}

function toggleMenu(el) {
	//const el = event.currentTarget;
	const openClass = '--menu-open';
	if (el.getAttribute('aria-expanded') === 'true') {

		el.setAttribute('aria-expanded', 'false');
		document.documentElement.classList.remove(openClass);
		window.removeEventListener('keydown', onKeyDown);

	} else {

		el.setAttribute('aria-expanded', 'true');

		firstFocusElement = el;


		const alist = document.querySelectorAll('.page-header__main-links a');
		lastFocusElement = alist[alist.length - 1];

		console.log(firstFocusElement);
		console.log(lastFocusElement);

		document.documentElement.classList.add(openClass);
		window.addEventListener('keydown', onKeyDown);
	}
}

function ready() {
	window.removeEventListener('load', ready);
	document.addEventListener('DOMContentLoaded', ready);

	// listen to the main button click
	const button = document.getElementById('menu-button');
	button.addEventListener('click', function (event) {
		const button = event.currentTarget;
		toggleMenu(button);
	});
}

if (document.readyState.match(/(completed|interactive)/i)) {
	ready();
} else {
	window.addEventListener('load', ready);
	document.addEventListener('DOMContentLoaded', ready);
}
